import { LoaderFunction } from 'react-router-dom';

// Sentry
import * as Sentry from '@sentry/react';

// GraphQL
import { selectWorkOrderWithChildren } from '../../../../gql/selectors/orders';
import { client } from '../../../../gql/client';
import {
  prefetchAccidentOptions,
  prefetchWizardCatalogs,
  prefetchChildrenSummaries,
} from '../../../../offline/prefetchOfflineData';
import { GET_ALL_CONFIGS } from '../../../../gql/queries/appConfig';

const loadWorkOrderDetails = async (id: string) => {
  try {
    return await selectWorkOrderWithChildren(true, id);
  } catch (err) {
    Sentry.captureException(err);
    console.log('> Work order loading error:', err);
    return false;
  }
};

export const LoaderWorkOrderDetailed: LoaderFunction = async ({ params }) => {
  // El trabajo entero vive aquí dentro, íntegro. Solo ha dejado de
  // esperarse: la promesa tiene que llegar PENDIENTE al `<Await>` para que
  // el router termine la navegación al instante y el `<Fallback>` enseñe el
  // Loader DENTRO de la pantalla nueva.
  const load = async () => {
  if (!params.id) return null;

  const data = await loadWorkOrderDetails(params.id);

  // Pre-cache data for offline creation. El catálogo de accidentes se
  // await-ea (1 query pequeña, cache-first = instantáneo en visitas
  // posteriores) para que las cadenas de `prefetchChildrenSummaries`
  // resuelvan sus catálogos por redirect en vez de ir a red por fila.
  await prefetchAccidentOptions();
  prefetchWizardCatalogs();
  await prefetchChildrenSummaries(data);
  // Calienta los feature flags que va a leer la ficha (`directionRequired`,
  // `showHoursType`). Antes eran dos `GET_CONFIG` por clave; desde que
  // `useFeatureFlag` lee del mapa agregado, esas dos entradas de caché no las
  // consultaba ya nadie — el prefetch calentaba una caché muerta.
  client.query({
    query: GET_ALL_CONFIGS,
    fetchPolicy: 'cache-first',
  }).catch(() => {});

  return data;
};

  return { data: load() };
};
